import { render, staticRenderFns } from "./OtherUserListAccordioin.vue?vue&type=template&id=97536cf4&lang=pug"
import script from "./OtherUserListAccordioin.vue?vue&type=script&lang=ts"
export * from "./OtherUserListAccordioin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports